import { Button } from '@ads/components-react';
import * as Dialog from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';

export interface DeleteSerieLangModalProps {
  readonly open: boolean;
  /** Título do idioma a excluir, interpolado na mensagem de confirmação. */
  readonly langTitle: string;
  readonly onConfirm: () => void;
  readonly onOpenChange: (open: boolean) => void;
}

/**
 * Modal de confirmação de remoção de Idioma da Série (Radix Dialog).
 */
export function DeleteSerieLangModal({
  open,
  langTitle,
  onConfirm,
  onOpenChange,
}: DeleteSerieLangModalProps) {
  const { t } = useTranslation('series');

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-none z-50 h-screen w-screen bg-base-gray-900 bg-opacity-medium backdrop-blur-soft" />
        <Dialog.Content
          aria-describedby={undefined}
          className="-translate-x-1/2 -translate-y-1/2 fixed top-1/2 left-1/2 z-50 flex w-full max-w-[26rem] flex-col gap-mini rounded-lg bg-ctx-layout-surface p-xxs shadow-level4 focus:outline-none"
        >
          <Dialog.Title className="text-ctx-content-title ts-heading-xs">
            {t('langs.delete.title')}
          </Dialog.Title>
          <p className="text-ctx-content-base ts-paragraph-xs">
            {t('langs.delete.body', { title: langTitle })}
          </p>
          <div className="flex justify-end gap-nano">
            <Dialog.Close asChild>
              <Button hierarchy="secondary" size="md">
                {t('langs.delete.cancel')}
              </Button>
            </Dialog.Close>
            <Button hierarchy="danger" size="md" onClick={onConfirm}>
              {t('langs.delete.confirm')}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
